<template>
    <div class="search-app__popular-suggestions">
        <div class="search-app__list-container">
            <h3 class="search-app__list-title">Popular Searches</h3>
            <ul class="search-app__list" >
                <li v-for="keyWord, index in popularKeyWords[0]" :key="keyWord.id" >
                    <a :href="onKeyWordPress(keyWord.searchterm)" v-if="index <= screenSizeCalculation()">
                        <span>{{ keyWord.searchterm }}</span>
                    </a>
                 </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'SearchTrendingSuggestions',
        props: ['popularKeyWords'],
        methods: {
            onKeyWordPress(term) {
                if(term){
                  return `${mint.routes.search}?q=${term}`
                }
            },
            screenSizeCalculation() {
                if (window.innerWidth < 768) {
                    return 4;  // 5 items in mobile
                } else {
                    return 6; // 7 items in desktop
                }
            }
        }
    };
</script>
